import { defineCustomElement } from 'vue';
import ToggleSwitch from '../../../src/shared/ToggleSwitch.vue';

const ToggleSwitchElement = defineCustomElement(ToggleSwitch, { shadowRoot: false });
customElements.define('toggle-switch', ToggleSwitchElement);
